import { SortingType } from 'constants/index';
import { IncidentSearchFields } from './types';

export const DEFAULT_SORT = {
    field: IncidentSearchFields.CASE_STATUS,
    type: SortingType.ASC,
};

